































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import * as types from '@/store/content/types'
import TreeMenu from './TreeMenu.vue'
import { Route } from 'vue-router'
import Content from '@/store/models/content'

@Component({ components: { TreeMenu } })
export default class Overview extends Vue {
  @Action('loadBookTree', { namespace: 'content' }) loadBookTree!: types.LoadBookTreeAction
  @Getter('bookTree', { namespace: 'content' }) bookTree!: types.BookTree
  @Getter('contentCache', { namespace: 'content' }) contentCache!: { [key: number]: Content }

  private created () {
    this.onRouteChanged(this.$route)
  }

  @Watch('$route')
  private onRouteChanged (newRoute: Route) {
    if (this.bookTree.book.id.toString() !== newRoute.params.id) {
      this.loadBookTree(newRoute.params.id)
    }
  }

  private pushParentIds (categoryId: number, idList: number[]) {
    idList.push(categoryId)
    const category = this.bookTree.categories[categoryId]
    if (category !== undefined && category.parent !== -1) {
      this.pushParentIds(category.parent, idList)
    }
  }

  private get title () {
    return this.bookTree.rootIds.length > 0 ? this.bookTree.categories[this.bookTree.rootIds[0]].type : ''
  }

  private get categoryCrumb () {
    const result: number[] = []
    if (this.$route.params.category !== undefined) {
      const routeCategory = parseInt(this.$route.params.category, 10)
      this.pushParentIds(routeCategory, result)
    }
    return result
  }
}
